let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1hbU8")).then(() => parcelRequire('kZFtj'));